import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import locationApi from '~/locationApi';
import { LOCATION_DETAILS_KEY } from '~/queries/keys';
import { CreatorLocationDetail } from '~/screens/MyAgency/components/SearchLocation';

export const useGetLocationDetails = (id?: string) => {
  return useQuery<AxiosResponse, AxiosError, CreatorLocationDetail, any>({
    queryKey: [LOCATION_DETAILS_KEY, { id }],
    queryFn: async () => {
      return locationApi
        .get(`/locations/mapbox/${id}/details`)
        .then((response) => response.data);
    },
    staleTime: 5 * 60 * 1000,
    enabled: !!id,
  });
};
